/*
 * ----------------------------------------------------------------------------
 * QUIZ — Perfil olfativo Le Sensier (engine de somatorio)
 * ----------------------------------------------------------------------------
 * Quiz de SOMATORIO: cada resposta vale X pontos (data-points), soma cai numa
 * faixa (score_min..score_max) -> 1 de N perfis -> recomendacao de produtos.
 *
 * Reusavel: inicializa CADA raiz `[data-quiz]` de forma independente. A mesma
 * engine roda na pagina (section quiz) e, na Fase 3, dentro do pop-up (pop-in)
 * SEM alteracao — basta o pop-up conter o mesmo markup `quiz-engine.liquid`.
 *
 * Garantias:
 *  - Selecao de perfil por faixa COM FALLBACK: score fora de qualquer faixa ->
 *    perfil mais proximo (menor distancia ao intervalo). NUNCA tela vazia.
 *  - E-mail OPCIONAL e NAO bloqueante: resultado aparece com ou sem e-mail.
 *  - Add-to-cart NAO e tratado aqui: a grade do resultado usa o markup Yampi
 *    ([data-yampi-buy-now] / name="checkout") interceptado por
 *    snippets/yampi-checkout-redirect.liquid (interceptor global).
 *
 * Fase 2 (storage via webhook n8n): POST fire-and-forget em submitResult().
 * O payload ja e montado e fica disponivel em instance.lastPayload.
 * ----------------------------------------------------------------------------
 */
(function () {
  'use strict';

  var READY_ATTR = 'data-quiz-ready';

  function QuizInstance(root) {
    this.root = root;
    this.form = root.querySelector('[data-quiz-form]');
    this.steps = Array.prototype.slice.call(root.querySelectorAll('[data-quiz-step]'));
    this.profiles = Array.prototype.slice.call(root.querySelectorAll('[data-quiz-profile]'));
    this.introStage = root.querySelector('[data-quiz-intro]');
    this.questionsStage = root.querySelector('[data-quiz-questions]');
    this.resultStage = root.querySelector('[data-quiz-result]');
    this.progressLabel = root.querySelector('[data-quiz-progress-label]');
    this.progressFill = root.querySelector('[data-quiz-progress-fill]');
    this.errorEl = root.querySelector('[data-quiz-error]');
    this.resultHeading = root.querySelector('[data-quiz-result-heading]');
    this.emailInput = root.querySelector('[data-quiz-email]');
    this.bottombar = root.querySelector('[data-quiz-bottombar]');

    this.currentStep = 0;
    this.collectEmail = root.getAttribute('data-collect-email') === 'true';
    this.customerId = root.getAttribute('data-customer-id') || '';
    this.loggedIn = root.getAttribute('data-logged-in') === 'true';
    this.lastPayload = null;

    this.bind();

    // Se nao ha intro configurado, comeca direto nas perguntas (sem tela em branco)
    if (this.introStage) {
      this.showStage('intro');
    } else {
      this.showStage('questions');
      this.goTo(0);
    }

    this.observeBottombar();
    this.fitQuestions();

    // So recalcula a altura quando a LARGURA muda (rotacao/redimensionamento real).
    // No Chrome iOS, rolar mostra/esconde a barra de URL e dispara 'resize' so com
    // mudanca de altura — ignorar isso evita recalcular/piscar durante o scroll.
    var self = this;
    var lastWidth = window.innerWidth;
    window.addEventListener('resize', function () {
      if (window.innerWidth === lastWidth) return;
      lastWidth = window.innerWidth;
      self.fitQuestions();
    });
    window.addEventListener('orientationchange', function () {
      lastWidth = window.innerWidth;
      self.fitQuestions();
    });
  }

  // Mobile: ajusta a altura do stage de PERGUNTAS a area visivel REAL (innerHeight,
  // confiavel no Chrome iOS, ao contrario de svh/dvh) descontando header + barra,
  // para as opcoes (flex) preencherem a tela sem vao e sem scroll.
  QuizInstance.prototype.fitQuestions = function () {
    var stage = this.questionsStage;
    if (!stage) return;
    if (!window.matchMedia('(max-width: 999px)').matches) {
      stage.style.height = '';
      return;
    }
    var cs = getComputedStyle(document.documentElement);
    var headerH = parseFloat(cs.getPropertyValue('--header-height')) || 0;
    var annH = parseFloat(cs.getPropertyValue('--announcement-bar-height')) || 0;
    var barH = this.bottombar ? this.bottombar.offsetHeight : 0;
    var avail = window.innerHeight - headerH - annH - barH - 24;
    stage.style.height = (avail > 300 ? avail + 'px' : '');
  };

  // Mobile: a barra fixa some quando o quiz sai da tela (rolar p/ o footer), para
  // nao cobrir as secoes abaixo. Mesmo padrao do monte-seu-kit (classe .is-visible).
  QuizInstance.prototype.observeBottombar = function () {
    if (!this.bottombar || !this.questionsStage) return;
    if (!('IntersectionObserver' in window)) {
      this.bottombar.classList.add('is-visible');
      return;
    }
    var bar = this.bottombar;
    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        bar.classList.toggle('is-visible', entries[i].isIntersecting);
      }
    }, { threshold: 0 });
    io.observe(this.questionsStage);
  };

  QuizInstance.prototype.bind = function () {
    var self = this;

    // Start (pode nao existir se intro desativado)
    var startBtns = this.root.querySelectorAll('[data-quiz-start]');
    Array.prototype.forEach.call(startBtns, function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        self.start();
      });
    });

    var prevBtns = this.root.querySelectorAll('[data-quiz-prev]');
    Array.prototype.forEach.call(prevBtns, function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        self.goTo(self.currentStep - 1);
      });
    });

    var nextBtns = this.root.querySelectorAll('[data-quiz-next]');
    Array.prototype.forEach.call(nextBtns, function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        self.next();
      });
    });

    var submitBtns = this.root.querySelectorAll('[data-quiz-submit]');
    Array.prototype.forEach.call(submitBtns, function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        self.submit();
      });
    });

    var restartBtns = this.root.querySelectorAll('[data-quiz-restart]');
    Array.prototype.forEach.call(restartBtns, function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        self.restart();
      });
    });

    if (this.form) {
      this.form.addEventListener('submit', function (e) {
        e.preventDefault();
      });
    }

    // Selecao de resposta: marca a label, limpa erro, atualiza estado dos botoes
    this.root.addEventListener('change', function (e) {
      var radio = e.target;
      if (!radio || !radio.classList || !radio.classList.contains('quiz__radio')) return;
      self.refreshSelectedClasses();
      self.clearError();
      self.refreshNavState();
    });
  };

  QuizInstance.prototype.refreshSelectedClasses = function () {
    var options = this.root.querySelectorAll('.quiz__option');
    Array.prototype.forEach.call(options, function (label) {
      var input = label.querySelector('.quiz__radio');
      if (input && input.checked) {
        label.classList.add('is-selected');
      } else {
        label.classList.remove('is-selected');
      }
    });
  };

  QuizInstance.prototype.showStage = function (stage) {
    if (this.introStage) this.introStage.hidden = stage !== 'intro';
    if (this.questionsStage) this.questionsStage.hidden = stage !== 'questions';
    if (this.resultStage) this.resultStage.hidden = stage !== 'result';
  };

  QuizInstance.prototype.start = function () {
    this.showStage('questions');
    this.goTo(0);
  };

  QuizInstance.prototype.goTo = function (index) {
    if (index < 0) index = 0;
    if (index > this.steps.length - 1) index = this.steps.length - 1;
    this.currentStep = index;

    this.steps.forEach(function (step, i) {
      step.hidden = i !== index;
    });

    this.clearError();
    this.refreshNavState();
    this.updateProgress();
    this.focusStep();
    this.fitQuestions();
  };

  QuizInstance.prototype.focusStep = function () {
    var step = this.steps[this.currentStep];
    if (!step) return;
    // Move o foco para o titulo da pergunta (tabindex=-1) para leitores de tela
    var legend = step.querySelector('[data-quiz-question]');
    if (legend && typeof legend.focus === 'function') {
      legend.focus();
    } else {
      var firstRadio = step.querySelector('.quiz__radio');
      if (firstRadio) firstRadio.focus();
    }
  };

  QuizInstance.prototype.stepAnswered = function (index) {
    var step = this.steps[index];
    if (!step) return false;
    return !!step.querySelector('.quiz__radio:checked');
  };

  QuizInstance.prototype.refreshNavState = function () {
    var isLast = this.currentStep === this.steps.length - 1;
    var answered = this.stepAnswered(this.currentStep);
    var prevBtns = this.root.querySelectorAll('[data-quiz-prev]');
    var nextBtns = this.root.querySelectorAll('[data-quiz-next]');
    var submitBtns = this.root.querySelectorAll('[data-quiz-submit]');

    Array.prototype.forEach.call(prevBtns, function (b) {
      b.hidden = false;
      b.disabled = false;
    });
    // "Proxima"/"Meu perfil" so habilitam quando a pergunta ATUAL foi respondida
    // (impede avancar/ver o perfil sem responder — inclusive a 5a pergunta).
    Array.prototype.forEach.call(nextBtns, function (b) {
      b.hidden = isLast;
      b.disabled = !answered;
      b.setAttribute('aria-disabled', String(!answered));
    });
    Array.prototype.forEach.call(submitBtns, function (b) {
      b.hidden = !isLast;
      b.disabled = !answered;
      b.setAttribute('aria-disabled', String(!answered));
    });

    // Esconde "voltar" no primeiro passo
    if (this.currentStep === 0) {
      Array.prototype.forEach.call(prevBtns, function (b) { b.hidden = true; });
    }
  };

  QuizInstance.prototype.updateProgress = function () {
    var total = this.steps.length;
    var current = this.currentStep + 1;
    if (this.progressLabel) {
      this.progressLabel.textContent = 'Pergunta ' + current + ' de ' + total;
    }
    if (this.progressFill) {
      var pct = total > 0 ? Math.round((current / total) * 100) : 0;
      this.progressFill.style.setProperty('--quiz-progress', pct + '%');
    }
  };

  QuizInstance.prototype.next = function () {
    if (!this.stepAnswered(this.currentStep)) {
      this.showError('Selecione uma resposta para continuar.');
      return;
    }
    this.goTo(this.currentStep + 1);
  };

  QuizInstance.prototype.showError = function (msg) {
    if (this.errorEl) {
      this.errorEl.textContent = msg;
      this.errorEl.hidden = false;
    }
  };

  QuizInstance.prototype.clearError = function () {
    if (this.errorEl) {
      this.errorEl.textContent = '';
      this.errorEl.hidden = true;
    }
  };

  QuizInstance.prototype.collectAnswers = function () {
    var answers = [];
    var score = 0;
    this.steps.forEach(function (step, i) {
      var checked = step.querySelector('.quiz__radio:checked');
      var points = checked ? parseInt(checked.getAttribute('data-points'), 10) || 0 : 0;
      var value = checked ? checked.value : null;
      score += points;
      answers.push({ question: i + 1, choice: value, points: points });
    });
    return { score: score, answers: answers };
  };

  // Selecao de perfil por faixa COM FALLBACK (perfil mais proximo).
  QuizInstance.prototype.pickProfile = function (score) {
    if (!this.profiles.length) return null;

    var exact = null;
    var best = null;
    var bestDist = Infinity;

    this.profiles.forEach(function (el) {
      var min = parseInt(el.getAttribute('data-score-min'), 10);
      var max = parseInt(el.getAttribute('data-score-max'), 10);
      // Faixa incompleta no editor (min/max vazio) -> perfil nao participa do match.
      // Evita virar "catch-all" silencioso que rouba todos os resultados.
      if (isNaN(min) || isNaN(max)) return;

      if (score >= min && score <= max && exact === null) {
        exact = el;
      }

      // Distancia ao intervalo (0 se dentro)
      var dist = 0;
      if (score < min) dist = min - score;
      else if (score > max) dist = score - max;

      if (dist < bestDist) {
        bestDist = dist;
        best = el;
      }
    });

    // Fallback final: nenhuma faixa valida configurada -> primeiro perfil (nunca tela vazia).
    return exact || best || this.profiles[0];
  };

  QuizInstance.prototype.submit = function () {
    // Valida que todas as perguntas foram respondidas
    for (var i = 0; i < this.steps.length; i++) {
      if (!this.stepAnswered(i)) {
        this.goTo(i);
        this.showError('Selecione uma resposta para continuar.');
        return;
      }
    }

    var result = this.collectAnswers();
    var profileEl = this.pickProfile(result.score);

    // Revela resultado
    this.showStage('result');
    this.profiles.forEach(function (el) { el.hidden = true; });

    var profileInfo = null;
    if (profileEl) {
      profileEl.hidden = false;
      profileInfo = {
        index: parseInt(profileEl.getAttribute('data-profile-index'), 10),
        name: profileEl.getAttribute('data-profile-name') || '',
        scoreMin: parseInt(profileEl.getAttribute('data-score-min'), 10),
        scoreMax: parseInt(profileEl.getAttribute('data-score-max'), 10)
      };
    }

    if (this.resultHeading && typeof this.resultHeading.focus === 'function') {
      this.resultHeading.focus();
    }

    // Monta payload (pronto para a Fase 2 — storage via webhook n8n)
    this.lastPayload = {
      quizId: this.root.getAttribute('data-quiz-id') || 'quiz',
      score: result.score,
      profile: profileInfo,
      answers: result.answers,
      customerId: this.customerId || null,
      loggedIn: this.loggedIn,
      email: this.collectEmail && this.emailInput ? (this.emailInput.value || '').trim() : null,
      timestamp: new Date().toISOString()
    };

    this.submitResult();
  };

  // Fase 2: persiste via webhook n8n em FIRE-AND-FORGET.
  QuizInstance.prototype.submitResult = function () {
    var payload = this.lastPayload;

    // ----------------------------------------------------------------------
    // FASE 2 — storage via webhook n8n (fire-and-forget).
    // O resultado NUNCA depende/trava desta chamada:
    //   - try/catch externo (se fetch indisponivel/lancar) + .catch() (rede/timeout)
    //   - keepalive: a request sobrevive ao descarregamento da pagina
    //   - sem URL configurada (data-webhook-url vazio) -> nao dispara
    // O secret e visivel no storefront (dado cosmetico) — decisao documentada.
    // ----------------------------------------------------------------------
    var webhookUrl = this.root.getAttribute('data-webhook-url') || '';
    var webhookSecret = this.root.getAttribute('data-webhook-secret') || '';
    if (webhookUrl) {
      try {
        fetch(webhookUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Quiz-Secret': webhookSecret
          },
          body: JSON.stringify(payload),
          keepalive: true,
          credentials: 'omit'
        }).catch(function () { /* nao trava o resultado */ });
      } catch (_) { /* nao trava o resultado */ }
    }

    // Log sem PII (sem email/customerId) — payload completo so server-side (n8n).
    if (window.console && typeof console.debug === 'function') {
      console.debug('[quiz] resultado: score', payload.score, '· perfil', payload.profile && payload.profile.name);
    }
  };

  QuizInstance.prototype.restart = function () {
    // Limpa selecoes
    var radios = this.root.querySelectorAll('.quiz__radio');
    Array.prototype.forEach.call(radios, function (r) { r.checked = false; });
    this.refreshSelectedClasses();
    this.profiles.forEach(function (el) { el.hidden = true; });
    if (this.emailInput) this.emailInput.value = '';
    this.lastPayload = null;
    this.currentStep = 0;
    this.showStage('questions');
    this.goTo(0);
  };

  function initRoot(root) {
    if (!root || root.getAttribute(READY_ATTR) === 'true') return;
    root.setAttribute(READY_ATTR, 'true');
    try {
      new QuizInstance(root);
    } catch (err) {
      if (window.console) console.error('[quiz] init failed:', err);
    }
  }

  function initAll(scope) {
    var ctx = scope && scope.querySelectorAll ? scope : document;
    var roots = ctx.querySelectorAll('[data-quiz]');
    Array.prototype.forEach.call(roots, initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  // Theme editor: re-inicializa quando a section recarrega
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target || document);
  });
})();
